import locationApi from '@/api/location'

const locationModel = {
  title: '',
  addressStreet: '',
  addressCity: '',
  addressCounty: '',
  addressState: '',
  addressZip: '',
  latitude: '',
  longitude: '',
  organization: 0
}

const state = {
  newLocation: Object.assign({}, locationModel),
  editLocation: false,

  viewLocationPending: false,
  viewLocationFailure: false,
  viewLocationSuccess: [],

  createLocationPending: false,
  createLocationFailure: false,
  createLocationSuccess: false,

  updateLocationPending: false,
  updateLocationFailure: false,
  updateLocationSuccess: false,

  deleteLocationPending: false,
  deleteLocationFailure: false,
  deleteLocationSuccess: false

}

const getters = {
  viewLocationPending: state => state.viewLocationPending,
  viewLocationFailure: state => state.viewLocationFailure,
  viewLocationSuccess: state => state.viewLocationSuccess,

  getCreateLocation: state => state.newLocation,
  getCreateLocationPending: state => state.createLocationPending,
  getCreateLocationFailure: state => state.createLocationFailure,
  getCreateLocationSuccess: state => state.createLocationSuccess,

  getEditLocation: state => state.editLocation,
  getUpdateLocationPending: state => state.updateLocationPending,
  getUpdateLocationFailure: state => state.updateLocationFailure,
  getUpdateLocationSuccess: state => state.updateLocationSuccess
}

const actions = {
  async getLocationRecords ({ commit, state }, payload) {
    commit('SET_LOCATION_STATE', { field: 'viewLocationPending', value: true })

    let response = await locationApi.getLocations(payload)

    commit('SET_LOCATION_STATE', { field: 'viewLocationPending', value: false })

    if (response.status !== 200) {
      // TO DO - Is there always a body.error?
      commit('SET_LOCATION_STATE', { field: 'viewLocationFailure', value: response.body.error })
      return
    }

    commit('SET_LOCATION_STATE', { field: 'viewLocationSuccess', value: response.body })
  },

  async createLocation ({ commit, state }, payload) {
    commit('SET_LOCATION_STATE', { field: 'createLocationPending', value: true })

    let response = await locationApi.createLocation(payload)

    commit('SET_LOCATION_STATE', { field: 'createLocationPending', value: false })

    if (response.status !== 200) {
      // TO DO - Is there always a body.error?
      commit('SET_LOCATION_STATE', { field: 'createLocationFailure', value: response.body.error })
      return
    }

    commit('ADD_LOCATION_IN_LIST', response.body)
    commit('SET_LOCATION_STATE', { field: 'createLocationSuccess', value: response.body })
    return response.body
  },

  async updateLocation ({ commit, state }, payload) {
    commit('SET_LOCATION_STATE', { field: 'updateLocationPending', value: true })

    let response = await locationApi.updateLocation(payload)

    commit('SET_LOCATION_STATE', { field: 'updateLocationPending', value: false })

    if (response.status !== 200) {
      commit('SET_LOCATION_STATE', { field: 'updateLocationFailure', value: response.body })
      return
    }

    commit('ADD_LOCATION_IN_LIST', response.body)
    commit('SET_LOCATION_STATE', { field: 'updateLocationSuccess', value: response.body })
  },

  async deleteLocation ({ commit, state }, payload) {
    commit('SET_LOCATION_STATE', { field: 'updateLocationPending', value: true })

    let response = await locationApi.deleteLocation(payload)

    commit('SET_LOCATION_STATE', { field: 'updateLocationPending', value: false })

    if (response.status !== 200) {
      commit('SET_LOCATION_STATE', { field: 'updateLocationFailure', value: response.body })
      return
    }
    commit('DELETE_LOCATION_FROM_LIST', response.body)
    commit('SET_LOCATION_STATE', { field: 'updateLocationSuccess', value: response.body })
  }
}

const mutations = {

  RESET_VIEW_LOCATION (state) {
    state.viewLocationSuccess = []
  },
  DELETE_LOCATION_FROM_LIST (state, response) {
    const existingIndex = state.viewLocationSuccess.findIndex((r) => r.id === response.id)
    if (existingIndex >= 0) {
      state.viewLocationSuccess.splice(existingIndex, 1)
    } else {
      console.log('did not find deleted location record in the program list')
    }
  },
  ADD_LOCATION_IN_LIST (state, response) {
    const existingIndex = state.viewLocationSuccess.findIndex((r) => r.id === response.id)

    // Update list with the returned record
    if (existingIndex >= 0) {
      state.viewLocationSuccess.splice(existingIndex, 1, response)
    } else {
      state.viewLocationSuccess.push(response)
      // TO DO - Sort?
    }
  },
  RESET_CREATE_LOCATION (state) {
    state.newLocation = Object.assign({}, locationModel)
    state.createLocationPending = false
    state.createLocationFailure = false
    state.createLocationSuccess = false
  },
  RESET_UPDATE_LOCATION (state) {
    state.editLocation = false
    state.updateLocationPending = false
    state.updateLocationFailure = false
    state.updateLocationSuccess = false
  },
  SET_LOCATION_STATE (state, payload) {
    const { field, value } = payload
    state[field] = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/location.js